<svg class="home-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4.30273" y="4.71921" width="5.76638" height="7.01317" rx="1" stroke="currentColor" stroke-width="2"
        stroke-linejoin="round" />
    <rect x="4.30273" y="15.7399" width="5.76638" height="5.00941" rx="1" stroke="currentColor" stroke-width="2"
        stroke-linejoin="round" />
    <rect x="13.9133" y="4.71921" width="5.76638" height="5.0094" rx="1" stroke="currentColor" stroke-width="2"
        stroke-linejoin="round" />
    <rect x="13.9133" y="13.7361" width="5.76638" height="7.01317" rx="1" stroke="currentColor" stroke-width="2"
        stroke-linejoin="round" />
</svg>